import { render } from "./Delete_Dialog.vue?vue&type=template&id=a2c62730&scoped=true&ts=true"
import script from "./Delete_Dialog.vue?vue&type=script&lang=ts"
export * from "./Delete_Dialog.vue?vue&type=script&lang=ts"

import "./Delete_Dialog.vue?vue&type=style&index=0&id=a2c62730&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c62730"]])

export default __exports__